import type { ReactNode } from 'react'

import { CONSTS } from 'config/objectConst'
import { useAppSelector } from 'shared/hooks'

import type { RootState } from '../../../../redux/store'

import { appSelectors } from '../../../../redux/reducers/app'
import { ModalIncludesTeam } from './ModalIncludesTeam'
import ModalNotTeam from './ModalNotTeam'
import { UpgradeSubscriptionTeam } from './UpgradeSubscriptionTeam'

const isLimitedTeamMember = (state: RootState) => {
	const { isTeamPlanAccessible, teamId } = appSelectors.persona(state)!
	return Boolean(!isTeamPlanAccessible && teamId)
}

const isCurrentUserOwner = (state: RootState) => {
	const { teamRole } = appSelectors.persona(state)!
	return teamRole === CONSTS.ROLES.Owner
}

const isSelfBoughSubscription = (state: RootState) => {
	const { personaId, subscriptionOwnerId } = appSelectors.persona(state)!
	return personaId === subscriptionOwnerId
}

const selectShowRequirePermissions = (state: RootState) =>
	isLimitedTeamMember(state) &&
	!isCurrentUserOwner(state) &&
	!isSelfBoughSubscription(state)

export function Fallbacks() {
	const showRequirePermissions = useAppSelector(selectShowRequirePermissions)

	const showOnBoardingScreen = useAppSelector(state => {
		const { isTeamPlanAccessible, subscriptionIsActive, teamId } =
			appSelectors.appProfile(state)!
		return (
			!teamId &&
			(isTeamPlanAccessible || (!isTeamPlanAccessible && !subscriptionIsActive))
		)
	})

	const showRequireSubscriptionUpgrade = useAppSelector(state => {
		const { isTeamPlanAccessible, subscriptionIsActive, teamId } =
			appSelectors.appProfile(state)!

		return (
			(isLimitedTeamMember(state) && !selectShowRequirePermissions(state)) ||
			(!isTeamPlanAccessible && !teamId && subscriptionIsActive)
		)
	})

	const content: ReactNode[] = []

	if (showRequirePermissions) {
		content.push(<ModalIncludesTeam />)
	}
	if (showOnBoardingScreen) {
		content.push(<ModalNotTeam />)
	}
	if (showRequireSubscriptionUpgrade) {
		content.push(<UpgradeSubscriptionTeam />)
	}

	return content
}
